import { jsx as _jsx } from "react/jsx-runtime";
import { faMotorcycle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
export var VehicleToggleIcon = function () {
    return _jsx(FontAwesomeIcon, { icon: faMotorcycle, size: "lg" });
};
